// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"n7-z"};